/**
 * `<ProtectedRoute>` — gate child routes behind Clerk auth (RLY-024 AC #8).
 *
 * Relies on Clerk's `<SignedIn>` / `<SignedOut>` render-aware components.
 * When the user is signed out we redirect to `/sign-in`; we render a
 * neutral fallback while Clerk is still resolving the session.
 */
import { SignedIn, SignedOut, useAuth } from "@clerk/clerk-react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <div
        data-testid="auth-loading"
        className="flex min-h-screen items-center justify-center text-muted-foreground"
      >
        Loading…
      </div>
    );
  }

  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <Navigate to="/sign-in" replace />
      </SignedOut>
    </>
  );
}

export default ProtectedRoute;
